import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import type { BackendModule, ReadCallback } from 'i18next'
import axios from 'axios'
import { unwrapEnvelopeData } from '@/shared/lib/api-envelope'
import { buildApiUrl } from '@/shared/lib/api-origin'

/**
 * Custom i18next backend that loads translations from the platform API.
 * Uses a raw axios instance since the consumer API client has a different baseURL.
 */
const ApiBackend: BackendModule = {
  type: 'backend',

  init() {
    // no-op
  },

  read(language: string, _namespace: string, callback: ReadCallback) {
    axios
      .get(buildApiUrl('/api/translations/'), {
        params: { language, source: 'FE' },
        withCredentials: true,
      })
      .then((res) => {
        callback(null, unwrapEnvelopeData(res.data))
      })
      .catch((err) => {
        console.warn('[i18n] Failed to load translations:', err)
        callback(null, {})
      })
  },
}

i18n
  .use(ApiBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
